function removeMapsScriptsFromHead() {
    const maps_scripts = [...document.head.querySelectorAll('script')]
        .filter(el => {
            try {
                return el?.src?.startsWith('https://maps.googleapis.com/maps');
            } catch (e) {
                return false;
            }
        });
    for (const mapsScript of maps_scripts) {
        document.head.removeChild(mapsScript);
    }
}

function eventDurationString(event) {
    const add_minutes = 20;
    const {conversation_duration, conversation_users_count, seats_min, seats_max} = event;
    const min_time = (seats_min / conversation_users_count * conversation_duration) + add_minutes;
    const max_time = (seats_max / conversation_users_count * conversation_duration) + add_minutes;
    const min_time_obj = {
        hours: Math.floor(min_time / 60),
        minutes: Math.floor(min_time % 60)
    };
    const max_time_obj = {
        hours: Math.floor(max_time / 60),
        minutes: Math.floor(max_time % 60)
    };
    if (min_time_obj.hours) {
        return `${(min_time / 60).toFixed(1)} - ${(max_time / 60).toFixed(1)} hour${max_time_obj.hours > 1 ? 's' : ''}`;
    } else if (max_time_obj.hours) {
        return `${min_time_obj.minutes} min - ${(max_time / 60).toFixed(1)} hour${max_time_obj.hours > 1 ? 's' : ''}`;
    } else {
        return `${min_time_obj.minutes} - ${max_time_obj.minutes} min`;
    }
}

function randomInputName() {
    return Math.random().toString(36).substring(2, 10);
}

function сreatePassword(PassLenght) {
    const Lenght = parseInt(PassLenght)
    const Charecters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*"
    let Password = "";
    for (var i = 0, n = Charecters.length; i < Lenght; ++i) {
        Password += Charecters.charAt(Math.floor(Math.random() * n));
    }
    console.log(Password)
    return Password;
}

export { removeMapsScriptsFromHead, eventDurationString, randomInputName, сreatePassword };
